export const sortOptions = [
  { value: 0, label: 'Item Code' },
  { value: 1, label: 'Item Description' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/orderformreport/helper/index.js